import React from 'react';
import {Form, Select} from "antd";
import {useSelector} from "react-redux";
import {useGetCompanyQuery} from "../slices/rootApiSlices/companyApiSlice";

const SearchCompany = ({onChange}) => {

    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading} = useGetCompanyQuery(user?.token);

    if (isLoading) {
        return (
            <div>yükleniyor</div>
        )
    }

    if (error) {
        return (
            <div>hata lütfen bekleyiniz</div>
        )
    }


    const onSearch = (value) => {
        console.log('search:', value);
    };


    return (
        <Form.Item
            name="company_id"
            rules={[{
                required: true,
                message: 'lütfen şirket seçiniz !'
            }]}
            style={{width: 'calc(100% - 8px)'}}
        >
            <Select
                showSearch
                placeholder="Firma seçiniz"
                optionFilterProp="children"
                onChange={onChange}
                loading={isLoading}
                onSearch={onSearch}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data !== null ? data?.data?.map((item) => {
                    return {
                        value: item.id,
                        label: item.title
                    }
                }) : null}
            />
        </Form.Item>
    );
};

export default SearchCompany;
